class MarqueeElement extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });

        this.shadowRoot.innerHTML = `
        <style>
          .marquee-container {
            overflow: hidden;
            white-space: nowrap;
            box-sizing: border-box;
            width: 100%;
            position: relative;
            opacity: 0;
          }
          .marquee-content {
            display: inline-flex;
            align-items: center;
            will-change: transform;
          }
          .marquee-item {
            display: flex;
            align-items: center;
            
            padding-right: calc(var(--space) * 2.5);
            margin-right: calc(var(--space) * 2.5);
            
            position: relative;
          }
          
          .marquee-item-image img {
            height: 28px;
            width: auto;
          }
          
          .marquee-item-text::after {
            content: '';
            position: absolute;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: #585D63;
            right: 0;
            top: 50%;
            transform: translate(50%, -50%);
          }
          .marquee-text {
            font-size: var(--body-text-mob);
            letter-spacing: 0;
            line-height: var(--body-text-lh-mob);
            font-family: var(--font-body-family);
            font-style: var(--font-body-style);
            font-weight: var(--font-body-weight);
          }
          .marquee-item-image {
              margin: 0 calc(var(--space) * 5);
            }
          
          @media (min-width: 1024px) {
            .marquee-item-text {
              padding-right: calc(var(--space) * 5.5);
              margin-right: calc(var(--space) * 5.5);
            }
            .marquee-item-image {
              margin: 0 calc(var(--space) * 7.75);
            }
          }
        </style>

        <div class="marquee-container">
          <div class="marquee-content">
            <slot></slot>
          </div>
        </div>
      `;
    }

    connectedCallback() {
        const isDesktop = this.getAttribute('desktop') === 'true';
        const isMobile = this.getAttribute('mobile') === 'true';

        if (isDesktop || isMobile) {
            this.initMarquee();
        }

        if (window.innerWidth > 1023) {
            this.classList.toggle('flex', isDesktop);
            this.classList.toggle('hidden', !isDesktop);
        } else {
            this.classList.toggle('flex', isMobile);
            this.classList.toggle('hidden', !isMobile);
        }
    }

    prepareMarquee() {
        const marqueeContent = this.shadowRoot.querySelector('.marquee-content');
        const slot = this.shadowRoot.querySelector('slot');
        const elements = slot.assignedElements();

        elements.forEach(item => {
            const clone = item.cloneNode(true);
            marqueeContent.appendChild(clone);
            item.remove();
        });

        const originalContent = Array.from(marqueeContent.children);
        while (marqueeContent.scrollWidth < marqueeContent.parentElement.clientWidth * 2) {
            originalContent.forEach(item => {
                marqueeContent.appendChild(item.cloneNode(true));
            });
        }
    }

    startMarquee() {
        const marqueeContent = this.shadowRoot.querySelector('.marquee-content');
        const speed = this.getAttribute('speed') || 100;
        let scrollPosition = 0;
        let lastTimestamp = performance.now();

        const animateMarquee = (timestamp) => {
            const deltaTime = timestamp - lastTimestamp;
            lastTimestamp = timestamp;

            scrollPosition -= (speed * deltaTime) / 1000;
            if (Math.abs(scrollPosition) >= marqueeContent.scrollWidth / 2) {
                scrollPosition = 0;
            }

            marqueeContent.style.transform = `translateX(${scrollPosition}px)`;
            requestAnimationFrame(animateMarquee);
        };

        requestAnimationFrame(animateMarquee);
    }

    initMarquee() {
        this.prepareMarquee();
        this.startMarquee();

        setTimeout(() => {
            let interval = setInterval(() => {
                if (gsap) {
                    gsap.to(this.shadowRoot.querySelector('.marquee-container'), {
                        duration: 0.5,
                        opacity: 1
                    });

                    clearInterval(interval);
                }
            }, 300);
        }, 1100);
    }
}

customElements.define('marquee-element', MarqueeElement);
